import React from 'react'

import { connect } from 'react-redux'

import includes from 'lodash/includes'
import { Box, Column, Row } from 'components/Layout'
import { InstallAppButton } from '../Buttons'
import { Form, FormSection } from 'components/Form'

import { BoxShell } from 'components/Shells'
import { Image } from 'components/Image'

import installForTeam from '../../assets/intros/girl-plug.png'

import { AppIsIncompleteBanner } from '../../views/Banners'

const AppDistributionPrivateForm = props => {
	const { app, isAppInstalledForTeam, isAppIncomplete } = props

	if (
		typeof app === 'undefined' ||
		typeof isAppInstalledForTeam === 'undefined'
	) {
		return (
			<Form>
				<BoxShell height={230} />
				<BoxShell height={160} />
			</Form>
		)
	}
	if (isAppIncomplete && app.clientId !== 'chatio-backend') {
		return (
			<AppIsIncompleteBanner
				incomplete={isAppIncomplete}
				appId={app.id}
			/>
		)
	}
	return app.customData.url ? (
		<Box
			header={'For you and your team'}
			body={
				<FormSection dark>
					<Row notPadded center>
						<Column width={2}>
							<Image
								src={installForTeam}
								width={190}
								height={200}
							/>
						</Column>
						<Column>
							<p>
								{isAppInstalledForTeam
									? 'This app is installed on your license! You can uninstall it at any time here or within the Agent App.'
									: 'Install this app, so you and all agents on your licence can use it.'}
							</p>
						</Column>
					</Row>
				</FormSection>
			}
			info={<InstallAppButton appId={app.id} />}
		/>
	) : null
}

const mapStateToProps = (state, ownProps) => {
	const currentAppId = ownProps.match.params.appId
	const currentApp = state.apps.items[currentAppId]

	const isAppInstalledForTeam = includes(
		state.installedApps.items,
		currentAppId
	)

	const isFeaturesCompleted =
		typeof currentApp !== 'undefined' ? currentApp.customData.url : false
	const isDisplayCompleted =
		typeof currentApp !== 'undefined'
			? currentApp.shortDescription && currentApp.description
			: false

	const isAppIncomplete = !(isFeaturesCompleted && isDisplayCompleted)

	return {
		app: currentApp,
		isAppInstalledForTeam,
		isAppIncomplete,
		initialValues: { appInstalledForTeam: isAppInstalledForTeam || false }
	}
}

const ConnectedAppDistributionPrivateForm = connect(mapStateToProps, null)(
	AppDistributionPrivateForm
)

export default ConnectedAppDistributionPrivateForm



// WEBPACK FOOTER //
// ./src/containers/Forms/AppDistributionPrivateForm.js